export default __webpack_public_path__ + "images/screenshot-search-14a07cd.webp";